"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Triggerable_1 = __importDefault(require("../util/Triggerable"));
require("./Expander.scss");
class Expander extends Triggerable_1.default {
  constructor(container, width, compressedHeight, name) {
    super();
    this.width = width;
    this.compressedHeight = compressedHeight;
    this.name = name;
    this.expanded = null;
    this.didFirstDraw = false;
    if (container === undefined) {
      return;
    }
    this.container = container.classed(name, true).classed('dh-chart-wrapper', true);
    this.expanderSection = container.append('div').classed('expandable', true).classed(name, true);
    this.svg = this.expanderSection.append('svg');
    this.expander = this.expanderSection.append('div').classed('hidden', true).classed('chart-expander', true);
  }
  initExpand() {
    this.expander.append('div').classed('arrow', true).classed('down', true);
    this.expander.append('div').classed('text', true).text('Show More');
    this.expander.append('div').classed('arrow', true).classed('down', true);
  }
  currentHeight(data, params) {
    const expanderHeight = 25;
    const dataHeight = this.height(data, params);
    return this.expanded ? dataHeight + expanderHeight : Math.min(this.compressedHeight, dataHeight);
  }
  static height() {
    return 0;
  }
  drawExpander(data, params, redrawFunc) {
    if (this.expanded === null) {
      this.expanded = params.expanded;
    }
    if (params.uncollapsible) {
      this.expanded = true;
    }
    const {
      expander
    } = this;
    const dataHeight = this.height(data, params);
    const height = this.currentHeight(data, params);
    const expanderText = this.expanded ? 'Show Less' : 'Show More';
    const gradientHeight = 100;
    if (params.autosize) {
      this.expanderSection.style('height', `${dataHeight}px`);
      expander.classed('hidden', true);
      return;
    }
    this.expanderSection.transition().style('height', `${height}px`);
    expander.style('display', params.uncollapsible ? 'none' : null);
    expander.select('.expand-rect').attr('height', gradientHeight).attr('transform', `translate(0, ${-gradientHeight})`);
    const text = expander.select('.text');
    expander.style('opacity', 1).classed('up', this.expanded).classed('down', !this.expanded).style('position', !this.expanded ? 'absolute' : null).classed('hidden', this.height(data, params) <= this.compressedHeight);
    text.text(expanderText);
    expander.on('click', () => {
      this.expanded = !this.expanded;
      expander.select('.expand-rect').attr('fill', this.expanded ? 'transparent' : `url(#${this.name}-expander-gradient)`);
      redrawFunc();
    });
  }
}
exports.default = Expander;